import Experience from "../../Experience";
export default class CardsBuilder {
    constructor() {
        this.experience = new Experience();
        this.container = document.querySelector('.homeCards-container')
        this.experience.router.main_data.data.cards.forEach((item, index) => {
            const buttonLabel = item.card_button || 'TBD'
            const isTbd = buttonLabel === 'TBD'
            const pdf = item.card_pdf || ''

            // Use a button + data-pdf attr for PDF links so the router never sees it.
            // <a> tags get intercepted by the global router click handler.
            const buttonHtml = isTbd
                ? `<span class="cta card-button card-button--tbd">${buttonLabel}</span>`
                : pdf
                    ? `<button class="cta card-button" data-pdf="${pdf}">${buttonLabel}</button>`
                    : `<a href="projects/${item.card_article_link.uid}" class="cta card-button">${buttonLabel}</a>`

            const card = `
                        <div class="card isRed">
                            <img src="${item.card_image.url}" class="" />
                            <div class="card-content">
                            <div class="tl-cross"></div>
                            <div class="tr-cross"></div>
                            <div class="bl-cross"></div>
                            <h1 class="card-title">${item.card_title[0].text}</h1>
                            ${buttonHtml}
                            <div class="card-data">
                                <p>${item.card_infos[0].text}</p>
                                <div class="line"></div>
                            </div>
                            </div>
                        </div>
             `
            this.container.insertAdjacentHTML('beforeend', card)
        })

        // Replace the click handler at the bottom of CardsBuilder.js with this:
        this.container.querySelectorAll('button[data-pdf]').forEach(btn => {
            btn.addEventListener('click', async (e) => {
                e.stopPropagation()
                const url = btn.dataset.pdf
                const filename = decodeURIComponent(url.split('/').pop().split('?')[0])
                try {
                    const res = await fetch(url)
                    const blob = await res.blob()
                    const blobUrl = URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = blobUrl
                    a.download = filename
                    a.click()
                    URL.revokeObjectURL(blobUrl)
                } catch (err) {
                    // Fallback: open in new tab if fetch fails
                    window.open(url, '_blank', 'noopener,noreferrer')
                }
            })
        })
    }
}